import { render, staticRenderFns } from "./CuttingMaterial.vue?vue&type=template&id=55e120a8"
import script from "./CuttingMaterial.vue?vue&type=script&lang=js"
export * from "./CuttingMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports